import React from "react";
import Column from "@amzn/meridian/column";

import WorkstationMetricsContextProvider from "./context/WorkstationMetricsContext";
import WorkstationMetricsTable from "./MetricsTable";
import SummaryTileView from "./SummaryTileView";
import PickFilterViewV2 from "../pickStatus/PickFilterViewV2";

const WorkstationView = (props) => {
    return (
        <Column spacingInset={"none large"} spacing={"none"}>
            <WorkstationMetricsContextProvider>
                <PickFilterViewV2/>
                <SummaryTileView/>
                <WorkstationMetricsTable/>
            </WorkstationMetricsContextProvider>
        </Column>
    );
}

export default WorkstationView


// WEBPACK FOOTER //
// ./src/components/workstationMetrics/WorkstationView.js